import React from 'react';

import ContactInfoSection from '../Components/Contact/ConstactSection.jsx';
import ContactHero from '../Components/Contact/ContactHero.jsx';
import TermsPrivacySection from '../Components/Contact/TermsPrivacySection.jsx';
import UnsubscribeSection from '../Components/Contact/UnsubscribeSection.jsx';

const ContactPage = () => {
  return (
    <main role="main">
      <ContactHero />
      <ContactInfoSection />
      <TermsPrivacySection />
      <UnsubscribeSection/>
    </main>
  );
};

export default ContactPage;
